import axiosInstance from "../Axios/axiosInstance";

const getAllFeedbacks = async () => {
  return await axiosInstance.get("/feedbacks/");
};

const getFeedbackById = async (id) => {
  return await axiosInstance.get(`/feedbacks/${id}`);
};

const addFeedback = async (data) => {
  console.log(data);
  return await axiosInstance.post("/feedbacks/", data);
};

const editFeedback = async (id, data) => {
  return await axiosInstance.put(`/feedbacks/${id}`, data);
};

const deleteFeedback = async (id) => {
  return await axiosInstance.delete(`/feedbacks/${id}`);
};

export default {
  getAllFeedbacks,
  getFeedbackById,
  addFeedback,
  editFeedback,
  deleteFeedback,
};
